import styled from 'styled-components'

export const PaginationCotainer = styled.div`
  width: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
  margin-top: 47px;


  .pagination {
    display: flex;
    list-style: none;
    align-items: center;
    li {
      padding: 0px 2.5px;
      a {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        font-size: 16px;
        color: ${props => props.theme.color.black4};
        text-decoration: none;

      }
      &.active {
        a {
          background-color: ${props => props.theme.color.red2};
          color: ${props => props.theme.color.white};
        }
      }
      &.prev,&.next {
        a {
          width: 28px;
          height: 28px;
          border: 1px solid ${props => props.theme.color.red2};
          svg {
            fill: ${props => props.theme.color.red2};
          }
        }
        &.disabled {
          a {
            border: 1px solid #d2d2d2;
            svg {
              fill: #d2d2d2;
            }
          }
        }
      }
    }

  }
  @media screen and (min-width: 1100px) {

  }

`

export const PaginationTotals = styled.p`
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: ${props => props.theme.font.size.sm};
  color: ${props => props.theme.color.black4};
  @media screen and (min-width: 1100px) {

  }

`
